import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList } from "vue"

import { computed } from 'vue';
import { SidebarLink } from '@/router/sidebarLinksCreator';
import { useDisplay } from 'vuetify';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBarLinkItem',
  props: {
    sidebarLink: {},
    nestLevel: {}
  },
  setup(__props: any) {

const vueProps = __props;

const xs = useDisplay().xs;

const tooltipLocation = computed<string>(() => {
  if (xs.value) {
    return 'top';
  }
  return 'right';
});
const tooltipTheme = computed<string>(() => {
  if (xs.value) {
    return 'dark';
  }
  return 'light';
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_SideBarLinkItem = _resolveComponent("SideBarLinkItem", true)!
  const _component_v_list_group = _resolveComponent("v-list-group")!

  return (vueProps.sidebarLink.childLinks?.length === 0)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (vueProps.sidebarLink.extarnal_link)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 0,
              "prepend-icon": vueProps.sidebarLink.icon,
              href: vueProps.sidebarLink.path,
              target: "_blank",
              title: vueProps.sidebarLink.name
            }, null, 8, ["prepend-icon", "href", "title"]))
          : (_openBlock(), _createBlock(_component_v_list_item, {
              key: 1,
              "prepend-icon": vueProps.sidebarLink.icon,
              to: vueProps.sidebarLink.path,
              title: vueProps.sidebarLink.name,
              class: _normalizeClass({ grandChild: __props.nestLevel === 2 })
            }, {
              default: _withCtx(() => [
                (vueProps.sidebarLink.tooltip)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      activator: "parent",
                      theme: tooltipTheme.value,
                      location: tooltipLocation.value,
                      "open-delay": 500
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(vueProps.sidebarLink.tooltip), 1)
                      ]),
                      _: 1
                    }, 8, ["theme", "location"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["prepend-icon", "to", "title", "class"]))
      ], 64))
    : (_openBlock(), _createBlock(_component_v_list_group, { key: 1 }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_list_item, _mergeProps(props, {
            "prepend-icon": vueProps.sidebarLink.icon,
            title: vueProps.sidebarLink.name
          }), null, 16, ["prepend-icon", "title"])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vueProps.sidebarLink.childLinks, (childLink) => {
            return (_openBlock(), _createBlock(_component_SideBarLinkItem, {
              key: childLink.name,
              "sidebar-link": childLink,
              "nest-level": __props.nestLevel + 1
            }, null, 8, ["sidebar-link", "nest-level"]))
          }), 128))
        ]),
        _: 1
      }))
}
}

})